import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Icon,
  Modal,
} from 'semantic-ui-react';
import { promptChangesMessage } from '../../actions/prompt';
import UploadSharedMedia from '../Opportunities/Overview/Form';
import {
  UPLOAD_DOCUMENT_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';


class AddSharedMedia extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    id: PropTypes.string,
    token: PropTypes.string,
    t: PropTypes.func,
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  handleOnClose = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const { t, onClose } = this.props;
    const { store } = this.context;

    const formInstance = this.form && this.form.getWrappedInstance ? this.form.getWrappedInstance() : this.form;

    if (formInstance && formInstance.state.uploads && formInstance.state.uploads.length > 0) {
      const callback = () => {
        if (onClose) onClose();
      };

      if (store) {
        store.dispatch(promptChangesMessage({
          message: t(UPLOAD_DOCUMENT_PROMPT, { ns: TRANSLATION_FILES.translation }),
          callback,
        }));
      }
      return;
    }

    if (onClose) onClose();
  }

  render() {
    const { open, onSubmit } = this.props;

    return (
      <Modal
        open={open}
        onClose={this.handleOnClose}
        closeIcon
        size="small"
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          <Icon name="file alternate outline" /> {this.props.t('Add document', { ns: TRANSLATION_FILES.translation })}
        </Modal.Header>
        <Modal.Content>
          <UploadSharedMedia
            ref={(ref) => { this.form = ref; }}
            onSubmit={(event, data) => {
              if (onSubmit) onSubmit(event, data);
            }}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(AddSharedMedia);



// WEBPACK FOOTER //
// ./src/containers/modals/AddSharedMedia.jsx